/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiScreeningListEntryInfo
 */
export interface ApiScreeningListEntryInfo {
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningListEntryInfo
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningListEntryInfo
     */
    name: string;
}

/**
 * Check if a given object implements the ApiScreeningListEntryInfo interface.
 */
export function instanceOfApiScreeningListEntryInfo(value: object): value is ApiScreeningListEntryInfo {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ApiScreeningListEntryInfoFromJSON(json: any): ApiScreeningListEntryInfo {
    return ApiScreeningListEntryInfoFromJSONTyped(json, false);
}

export function ApiScreeningListEntryInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningListEntryInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
    };
}

export function ApiScreeningListEntryInfoToJSON(json: any): ApiScreeningListEntryInfo {
    return ApiScreeningListEntryInfoToJSONTyped(json, false);
}

export function ApiScreeningListEntryInfoToJSONTyped(value?: ApiScreeningListEntryInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

